module.exports = __webpack_public_path__ + "assets/bf-nl.a5d0f092.svg";